import { Reducer } from 'redux';
import { EventTypesTypes, IEventTypesState } from './types';

const initialState: IEventTypesState = [];

const reducer: Reducer<IEventTypesState> = (state = initialState, action) => {
  switch (action.type) {
    case EventTypesTypes.GET_UNI_EVENT_TYPES_SUCCESS: {
      return [...action.payload];
    }
    default:
      return state;
  }
};

export { reducer as eventTypesReducer };
